module.exports = __webpack_public_path__ + "img/layer-save-jobs.e0530ab.png";